<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
}
#app {
  height: 100%;
  display: flex;
}

.mint-toast.is-placemiddle{
   z-index: 999999999 !important;
}
.mint-indicator-wrapper{
  z-index: 999999999 !important;
}
.mint-indicator-mask{
  z-index: 999999999 !important;
}
.van-image-preview{
  z-index: 999999999 !important;
}
.van-image-preview__overlay{
  z-index: 999999999 !important;
}
.mint-msgbox-wrapper{
   z-index: 999999999 !important;
}
#__vconsole .vc-switch{
  z-index: 999999999 !important;
}
#__vconsole .vc-panel{
    z-index: 999999999 !important;
}
</style>



// WEBPACK FOOTER //
// src/feiyi2/App.vue